import gql from 'graphql-tag';

const getTemplateDetailsQuery = gql`
query getTemplateDetails($templateId: String!) {
  getTemplateDetails(templateId: $templateId) {
    splashTemplatesDescriptorId
    templateName
    contents
    status
    brandingColor
    archivedAt
  }
}
`;

const getTemplateDetails = (templateId) => ({
  query: getTemplateDetailsQuery,
  module: 'splash',
  ignoreCache: true,
  buildVariables: () => ({ templateId })
});

export default getTemplateDetails;